"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reduce;
exports.getActiveReminders = getActiveReminders;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _concat2 = _interopRequireDefault(require("lodash/concat"));

var types = _interopRequireWildcard(require("../actions/actionTypes"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var initialState = {
  reminders: []
};

function reduce() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case types.REMINDERS_FETCHED:
      return _objectSpread({}, state, {
        reminders: (0, _concat2.default)(action.reminders, state.reminders)
      });

    case types.MARK_REMINDER_AS_SHOWN:
      return _objectSpread({}, state, {
        reminders: state.reminders.filter(function (item) {
          var found = false;

          for (var i = 0; i < action.ids.length; ++i) {
            if (item.id == action.ids[i]) {
              found = true;
              break;
            }
          }

          return !found;
        })
      });

    case types.MARK_ALL_REMINDERS_AS_SHOWN:
      return _objectSpread({}, state, {
        reminders: []
      });

    default:
      return state;
  }
}

function getActiveReminders(state) {
  return state.reminders.reminders;
}